// extracted by mini-css-extract-plugin
export default {"container":"OnMapSpinner_container__GKKVs"};